import React, { useMemo } from "react";

const VoucherPagination = ({ metaData = {}, onPageChange = () => {} }) => {
  const totalPages = Math.max(1, Number(metaData?.totalPages) || 1);
  const currentPage = Math.min(Math.max(1, Number(metaData?.page) || 1), totalPages);

  const canPrev = currentPage > 1;
  const canNext = currentPage < totalPages;

  const goToPage = (p) => {
    const page = Number(p);
    if (!Number.isFinite(page)) return;
    if (page < 1 || page > totalPages || page === currentPage) return;
    onPageChange(page);
  };

  // keep this in case you later want numbered pagination
  const pages = useMemo(() => {
    const out = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) out.push(i);
      return out;
    }
    const left = Math.max(2, currentPage - 1);
    const right = Math.min(totalPages - 1, currentPage + 1);

    out.push(1);
    if (left > 2) out.push("ellipsis-left");
    for (let i = left; i <= right; i++) out.push(i);
    if (right < totalPages - 1) out.push("ellipsis-right");
    out.push(totalPages);
    return out;
  }, [currentPage, totalPages]);

  return (
    <div className="p-3 pt-2 d-flex justify-content-between align-items-center">
      <button
        type="button"
        className="btn of-btn-ghost"
        onClick={() => goToPage(currentPage - 1)}
        disabled={!canPrev}
      >
        <i className="fas fa-chevron-left mr-2" />
        Previous
      </button>

      <div className="text-muted small">
        Page <b>{currentPage}</b> / {totalPages}
      </div>

      <button
        type="button"
        className="btn of-btn-ghost"
        onClick={() => goToPage(currentPage + 1)}
        disabled={!canNext}
      >
        Next
        <i className="fas fa-chevron-right ml-2" />
      </button>
    </div>
  );
};

export default VoucherPagination;
